import { client, client_dp } from "../App";
import { buId, CUSTOMER_API_URL } from "../constant";
import { GET_ALL_STATES, GET_ESCALATION_MATRIX } from "./dealers.queries";
import axios from "axios";
import { getToken } from "../utilities/utilsFunction";

export const GetAllState = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/allState`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetAllDistrict = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/allDistricts`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetAllTehsil = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/allTehsils`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetAllDealers = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/dealers/${buId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
